(function () {
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  document.querySelectorAll('[data-sk-form]').forEach(function (form) {
    var btn = form.querySelector('[data-sk-atc]');
    var label = btn ? btn.getAttribute('data-label') : 'Add to cart';
    var sticky = document.querySelector('[data-sk-sticky]');
    var sel = sticky && sticky.querySelector('select');
    var sPrice = sticky && sticky.querySelector('[data-sk-sticky-price]');
    var sBtn = sticky && sticky.querySelector('.sk-sticky__btn');
    function update(r) {
      if (!r) return;
      var avail = r.getAttribute('data-available') === 'true';
      var p = money(parseInt(r.getAttribute('data-price'), 10));
      if (btn) { btn.disabled = !avail; btn.textContent = avail ? label + ' - ' + p : 'Sold out'; }
      if (sel) sel.value = r.value;
      if (sPrice) sPrice.textContent = p;
      if (sBtn) sBtn.disabled = !avail;
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'id') update(e.target); });
    if (sel) sel.addEventListener('change', function () {
      var r = form.querySelector('input[name="id"][value="' + sel.value + '"]');
      if (r) { r.checked = true; update(r); }
    });
    update(form.querySelector('input[name="id"]:checked'));
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
  });

  document.querySelectorAll('[data-sk-gal]').forEach(function (g) {
    var main = g.querySelector('[data-sk-gal-main]');
    var thumbs = [].slice.call(g.querySelectorAll('[data-src]'));
    if (!main || !thumbs.length) return;
    var i = 0;
    function go(n) {
      i = (n + thumbs.length) % thumbs.length;
      main.src = thumbs[i].getAttribute('data-src');
      main.removeAttribute('srcset');
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    g.querySelectorAll('[data-sk-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.getAttribute('data-sk-step'), 10)); });
    });
  });

  document.querySelectorAll('[data-sk-tabs]').forEach(function (w) {
    var tabs = w.querySelectorAll('[role="tab"]');
    var panels = w.querySelectorAll('[role="tabpanel"]');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });

  document.querySelectorAll('[data-sk-scroller]').forEach(function (w) {
    w.querySelectorAll('[data-sk-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var tr = w.querySelector('[role="tabpanel"]:not([hidden]) [data-sk-track]') || w.querySelector('[data-sk-track]');
        if (!tr) return;
        var card = tr.firstElementChild;
        var dx = card ? card.getBoundingClientRect().width + 20 : 300;
        tr.scrollBy({ left: dx * parseInt(b.getAttribute('data-sk-dir'), 10), behavior: 'smooth' });
      });
    });
  });

  document.querySelectorAll('[data-sk-arrive]').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-sk-arrive'), 10) || 5;
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
    el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });
})();
